import { GtmTracker } from '@/modules/common/services/analytics';
import { Categories } from '@/types/models/Analytics';

const trackEvent = GtmTracker.trackerWithDefaultProps({
  category: Categories.PEX
});

export function trackingRefusalSuggestedInvestment() {
  trackEvent({
    action: 'Clique recusar',
    label: 'Detalhe - Sugestao de investimento'
  });
}

const trackAmplitudeEventPortfolio = GtmTracker.trackerWithDefaultProps({
  digital_experience: 'investor',
  experience_section: 'portfolio'
});

export function refuseInvestmentSuggestedAmplitude() {
  trackAmplitudeEventPortfolio({
    page_screen: 'portfolio_investment_suggestion',
    event_type: 'click',
    page_screen_section: 'body',
    event_name: 'refuse_investment_suggestion',
    event_target: 'Recusar'
  });
}

export function trackingCreatePortfolio() {
  trackEvent({
    category: 'PEX',
    action: 'Load',
    label: 'Sucesso - Sugestao de investimento'
  });
}

export function trackingSuggestedInvestment() {
  trackEvent({
    action: 'Clique aceitar',
    label: 'Detalhe - Sugestao de investimento'
  });
}

export function acceptInvestmentSuggestedAmplitude() {
  trackAmplitudeEventPortfolio({
    page_screen: 'portfolio_investment_suggestion',
    event_type: 'click',
    page_screen_section: 'body',
    event_name: 'accept_investment_suggestion',
    event_target: 'Aceitar'
  });
}
